/** What the plan editor showed on one render: open or not, and which plan. */
export interface PlanEditorView {
  open: boolean;
  planId: string | null;
}

/**
 * Whether the map should fit itself to the owner's plan after the editor
 * went from `prev` to `next`. Only a switch from one plan to another while
 * the editor stays open fits: choosing a plan in the switcher is a request
 * to see that plan. Opening the editor does not, because the owner may have
 * panned to the spot they want to plan, and it must not fly them away to
 * defenses they drew elsewhere. A first draw (no plan, then a new one) and a
 * plan arriving after a slow load don't fit either; the owner is already
 * looking at what they mean to see. "Zoom to plan" in the header menu is the
 * on-demand fit.
 */
export function shouldFitOnPlanChange(prev: PlanEditorView, next: PlanEditorView): boolean {
  return prev.open && next.open && !!prev.planId && !!next.planId && prev.planId !== next.planId;
}
